import { motion } from "framer-motion";
import { PlusIcon } from "@heroicons/react/24/outline";
import { FaSpinner } from "react-icons/fa6";

import { CreatableWallet } from "../../../utils/creatableWallets";
import Flag from "../../Flag";

interface CreateWalletTileProps {
  wallet: CreatableWallet;
  creating?: boolean;
  onCreate: (wallet: CreatableWallet) => void;
}

export default function CreateWalletTile({
  wallet,
  creating = false,
  onCreate,
}: CreateWalletTileProps) {
  return (
    <motion.button
      type="button"
      whileTap={{ scale: 0.97 }}
      disabled={creating}
      onClick={() => onCreate(wallet)}
      className="flex min-h-[104px] w-40 shrink-0 flex-col items-center justify-center gap-2 rounded-xl border-2 border-dashed border-gray-300 text-gray-500 transition-colors hover:border-primary hover:text-primary disabled:opacity-60"
      aria-label={`Create ${wallet.name} wallet`}
    >
      {creating ? (
        <FaSpinner className="h-6 w-6 animate-spin text-primary" />
      ) : (
        <span className="relative flex items-center justify-center">
          <Flag currency={wallet.currency} className="h-7 w-7" />
          <span className="absolute -bottom-1 -right-1 flex h-4 w-4 items-center justify-center rounded-full bg-primary text-white">
            <PlusIcon className="h-3 w-3" />
          </span>
        </span>
      )}
      <span className="text-xs font-medium">
        {creating ? "Creating…" : `Add ${wallet.currency}`}
      </span>
    </motion.button>
  );
}
